module.exports = __webpack_public_path__ + "img/page.81734a12.png";